export const SET_ORDERS = (state, data) => {
  state.orders = data.items;
  state.orders_total = data.total;
}

export const SET_ORDER = (state, order) => {
  state.order = order;
}